<template>
  <div>
    <div v-if="shouldDisplaySupplierLogo" data-test-supplier class="product-header__supplier-logo">
      <img
        v-if="shouldDisplaySupplierLogo && !isFarmi"
        :src="product.supplierLogo"
        class="image supplier-logo"
        :alt="i18n._('Marque partenaire')"
        @click="goToSupplierSearch()"
        data-test="supplier-logo"
      />
    </div>
    <div v-else-if="product.supplier && !isFarmi" data-test="supplier-fallback" class="product-header__supplier">
      {{ product.supplier }}
    </div>
  </div>
</template>
<script lang="ts">
import type { PropType } from 'vue'
import { computed, defineComponent } from 'vue'
import { isFarmi } from '@b2ag/app-brands'
import { i18n } from '@b2ag/locale'
import type { Product } from '../product.interface'

const MAX_SUPPLIER_SCORE = 20
import { isNil } from '@b2ag/utils/src/isNil'

export default defineComponent({
  emits: ['goToProductSearch'],
  props: {
    product: {
      type: Object as PropType<Product>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const isSupportedSupplier = computed(() => props.product.supplierScore <= MAX_SUPPLIER_SCORE)

    const shouldDisplaySupplierLogo = computed(() => {
      return !isNil(props.product?.supplierLogo) && isSupportedSupplier.value
    })

    function getCommonCategoryPath() {
      return props.product.categories[0].filter((commonCategoryLevel) => {
        return props.product.categories
          .slice(1)
          .every((otherCategoryPath) =>
            otherCategoryPath.some((categoryLevel) => categoryLevel.code === commonCategoryLevel.code),
          )
      })
    }

    function goToSupplierSearch() {
      if (!isSupportedSupplier.value) return
      if (props.product.supplierUniversePageLink) {
        window.open(props.product.supplierUniversePageLink, '_blank')
      } else {
        const commonCategoryPath = getCommonCategoryPath()
        const lastCommonCategoryLevel = commonCategoryPath[commonCategoryPath.length - 1]
        emit('goToProductSearch', {
          categoryCode: lastCommonCategoryLevel.code,
          supplierName: props.product.supplier,
        })
      }
    }

    return {
      shouldDisplaySupplierLogo,
      goToSupplierSearch,
      isFarmi,
      i18n,
    }
  },
})
</script>
<style lang="scss" scoped>
.supplier-logo {
  cursor: pointer;
  margin-right: var(--spacing-3);
  border: #ccd1d3 1px solid;
  border-radius: 4px;
  padding: 4px;
}

.product-header__supplier {
  font-weight: normal;
  text-transform: uppercase;
  font-size: 1.28rem;
  height: 1.2em;

  @media (min-width: $breakpoint-md) {
    font-size: 1.6rem;
    margin: 5px 0;
  }
}

.image.supplier-logo {
  height: 80px;
  width: 80px;
}
</style>
